// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page[data-v-74f96f33]{margin-top:20px}.item+.item[data-v-74f96f33]{border-top:1px solid #e7e7e7;margin-top:0;padding-top:20px}.left-list[data-v-74f96f33]{min-height:500px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
